export const analyticsId = {
    CONTRACT_EASY_LOAN_STEP_1_VIEW: "CONTRACT_EASY_LOAN_STEP_1_VIEW",
    CONTRACT_EASY_LOAN_STEP_2_VIEW: "CONTRACT_EASY_LOAN_STEP_2_VIEW",
    CONTRACT_EASY_LOAN_STEP_3_VIEW: "CONTRACT_EASY_LOAN_STEP_3_VIEW",
    CONTRACT_EASY_LOAN_STEP_1_SUCCESS: "CONTRACT_EASY_LOAN_STEP_1_SUCCESS",
    CONTRACT_EASY_LOAN_STEP_2_SUCCESS: "CONTRACT_EASY_LOAN_STEP_2_SUCCESS",
    CONTRACT_EASY_LOAN_STEP_3_SUCCESS: "CONTRACT_EASY_LOAN_STEP_3_SUCCESS",
    CONTRACT_EASY_LOAN_WIZARD_ERROR: "CONTRACT_EASY_LOAN_WIZARD_ERROR",
    CONTRACT_EASY_LOAN_WIZARD_SUCCESS: "CONTRACT_EASY_LOAN_WIZARD_SUCCESS",
    CONTRACT_EASY_LOAN_WIZARD_NO_OFFER: "CONTRACT_EASY_LOAN_WIZARD_NO_OFFER",
    CLICK_BREADCRUMB_01: "CLICK_BREADCRUMB_01",
};

const commonFields = () => ({
    sectionFamily: "banking",
    sectionCategory: "products",
    sectionName: "loans",
    serviceType: "productContracting",
    interactionType: "funnel",
    processType: "loanContracting",
});

export const catalogue = {
    [analyticsId.CONTRACT_EASY_LOAN_STEP_1_VIEW]: () => ({
        ...commonFields(),
        event_name: "step_simulator",
        pageName: "/loanContracting/step1/simulator",
        processStep: "step1",
        processDetail: "simulator",
        productName: "easyLoan",
    }),
    [analyticsId.CONTRACT_EASY_LOAN_STEP_2_VIEW]: ({ data }) => ({
        ...commonFields(),
        event_name: "step_ine",
        pageName: "/loanContracting/step2/loanContractingINE",
        processStep: "step2",
        processDetail: "loanContractingINE",
        productName: "easyLoan",
        data: `${data}%`,
    }),
    [analyticsId.CONTRACT_EASY_LOAN_STEP_3_VIEW]: ({ data }) => ({
        ...commonFields(),
        event_name: "step_documentation",
        pageName: "/loanContracting/step3/documentation",
        processStep: "step3",
        processDetail: "documentation",
        productName: "easyLoan",
        data: `${data}%`,
    }),
    [analyticsId.CONTRACT_EASY_LOAN_STEP_1_SUCCESS]: () => ({
        event_name: "event_success",
        action: "success",
        format: "steps",
        component: "funnel",
        element: "simulator",
        data: true,
    }),
    [analyticsId.CONTRACT_EASY_LOAN_STEP_2_SUCCESS]: () => ({
        event_name: "event_success",
        action: "success",
        format: "steps",
        component: "funnel",
        element: "loanContractingINE",
        data: true,
    }),
    [analyticsId.CONTRACT_EASY_LOAN_STEP_3_SUCCESS]: () => ({
        event_name: "event_success",
        action: "success",
        format: "steps",
        component: "funnel",
        element: "documentation",
    }),
    [analyticsId.CONTRACT_EASY_LOAN_WIZARD_ERROR]: ({
        data,
        errorMessage,
    }) => ({
        ...commonFields(),
        event_name: "step_error",
        pageName: "/loanContracting/error/requestError",
        processStep: "error",
        processDetail: "requestError",
        errorCategory: "requestError",
        errorDescription: errorMessage,
        productName: "easyLoan",
        data: `${data}%`,
    }),
    [analyticsId.CONTRACT_EASY_LOAN_WIZARD_SUCCESS]: ({ data }) => ({
        ...commonFields(),
        event_name: "step_application_success",
        pageName: "/loanContracting/applicationSuccess",
        processStep: "applicationSuccess",
        productName: "easyLoan",
        data: `${data}%`,
    }),
    [analyticsId.CONTRACT_EASY_LOAN_WIZARD_NO_OFFER]: () => ({
        ...commonFields(),
        event_name: "step_application_no_offer",
        pageName: "/loanContracting/noOffer",
        processStep: "noOffer",
        productName: "easyLoan",
    }),
    [analyticsId.CLICK_BREADCRUMB_01]: () => ({
        categoriaEvento: window.utag_last_name,
        accionEvento: "préstamos e hipotecas",
        etiquetaEvento: "breadcrumb01",
    }),
};